/**
 * Rails CSRF token from the meta tag rendered by `csrf_meta_tags` in the layout.
 *
 * @returns {string | undefined}
 */
export function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta?.getAttribute("content") ?? undefined;
}
